/** Spanish UI copy for legal notices and registration consents (all jurisdictions). */

export const LEGAL_COPY_ES = {
  toggleCollapsed: 'Ver aviso completo',
  toggleExpanded: 'Ocultar aviso completo',
  fieldRequired: 'Este campo es obligatorio',
  consents: {
    AU: {
      privacyLink: 'Aviso de recopilación de privacidad',
      privacy:
        'He leído y comprendido el Aviso de Recopilación de Privacidad de Domio.world y consiento la recopilación, uso y almacenamiento de mi información personal según se describe en el mismo.',
      sensitive:
        'Consiento que Domio.world recopile y trate mi información personal sensible (incluidos documentos de identidad y registros financieros) para los fines descritos en el Aviso de Recopilación de Privacidad.',
    },
    CO: {
      privacyLink: 'Aviso de Privacidad',
      privacy:
        'He leído y comprendido el Aviso de Privacidad de Domio.world y autorizo el tratamiento de mis datos personales para las finalidades en él indicadas, de conformidad con la Ley 1581 de 2012.',
      sensitive:
        'Autorizo expresamente el tratamiento de mis datos sensibles (documentos de identidad y registros financieros) para los fines descritos en el Aviso de Privacidad.',
    },
    ES: {
      privacyLink: 'Información sobre Protección de Datos',
      privacy:
        'He leído y acepto la Información sobre Protección de Datos de Domio.world y consiento el tratamiento de mis datos personales para la prestación del servicio, conforme al RGPD (UE) 2016/679 y la LOPDGDD 3/2018.',
      marketing:
        'Acepto recibir comunicaciones comerciales de Domio.world sobre novedades, ofertas y actualizaciones del servicio. Puedo retirar este consentimiento en cualquier momento.',
      sensitive:
        'Consiento el tratamiento de mis datos identificativos y financieros (categorías especiales) para la verificación de identidad y gestión de contratos de arrendamiento.',
    },
  },
  notices: {
    AU: {
      sections: [
        {
          title: 'Domio.world — Aviso de recopilación de privacidad',
          paragraphs: [
            'Este Aviso de Recopilación de Privacidad explica cómo Domio.world (nosotros) recopila, usa, almacena y divulga su información personal cuando se registra y utiliza nuestra plataforma de gestión de propiedades.',
          ],
        },
        {
          title: 'Qué información personal recopilamos',
          paragraphs: [
            'Podemos recopilar: datos de identidad y contacto (nombre, correo electrónico, teléfono, rol); credenciales de cuenta (contraseñas cifradas); información de propiedades, arrendamientos y finanzas que ingrese o cargue; documentos de identidad y registros financieros cuando los proporcione para verificación o procesamiento documental con IA; datos de uso, dispositivo y registros; comunicaciones con nosotros; y preferencias de marketing cuando otorgue su consentimiento.',
          ],
        },
        {
          title: 'Cómo recopilamos su información personal',
          paragraphs: [
            'Recopilamos información directamente de usted al registrarse, completar su perfil, cargar documentos o usar funciones de la plataforma. También podemos recopilarla automáticamente mediante cookies, analítica y registros del servidor, y de servicios integrados que autorice (como correo o almacenamiento).',
          ],
        },
        {
          title: 'Por qué recopilamos, usamos y divulgamos información personal',
          paragraphs: [
            'Usamos su información para prestar y mejorar el servicio Domio.world; crear y administrar su cuenta; procesar registros de propiedades, arrendamientos, mantenimiento y finanzas; ejecutar extracción documental asistida por IA cuando esté habilitada; enviar notificaciones de servicio y seguridad; cumplir obligaciones legales; y, con su consentimiento, enviar comunicaciones comerciales. Divulgamos información a proveedores que nos asisten (hosting, correo, analítica, procesamiento con IA) bajo obligaciones contractuales de privacidad, y cuando la ley lo exija.',
          ],
        },
        {
          title: 'A quién divulgamos información personal',
          paragraphs: [
            'Las divulgaciones pueden realizarse a: proveedores de infraestructura en la nube y bases de datos; proveedores de correo electrónico; socios de IA y procesamiento documental; asesores profesionales; reguladores y autoridades cuando sea requerido; y otros usuarios dentro de su organización o portafolio según su rol y permisos.',
          ],
        },
        {
          title: 'Divulgación en el extranjero',
          paragraphs: [
            'Su información personal puede almacenarse o procesarse en Australia y otros países donde operan nuestros proveedores. Cuando divulgamos información en el extranjero, adoptamos medidas razonables para que los destinatarios la traten de manera coherente con los Principios de Privacidad Australianos, incluidas salvaguardas contractuales cuando corresponda.',
          ],
        },
        {
          title: 'Almacenamiento y seguridad',
          paragraphs: [
            'Conservamos la información personal mientras su cuenta esté activa y según sea necesario para prestar el servicio, cumplir obligaciones legales y resolver disputas. Implementamos medidas técnicas y organizativas que incluyen cifrado en tránsito, controles de acceso y registro de auditoría. Ningún método de transmisión o almacenamiento es completamente seguro.',
          ],
        },
        {
          title: 'Sus derechos',
          paragraphs: [
            'Sujeto a la ley aplicable, puede solicitar acceso, corrección o eliminación de su información personal, y retirar el consentimiento cuando el tratamiento se base en consentimiento. La retirada puede limitar ciertas funciones. Puede presentar una queja si considera que hemos manejado mal su información.',
          ],
        },
        {
          title: 'Quejas',
          paragraphs: [
            'Si tiene una queja de privacidad, contacte a nuestro Oficial de Privacidad con los datos indicados abajo. Reconoceremos su queja y responderemos en un plazo razonable. Si no está satisfecho, puede contactar a la Oficina del Comisionado Australiano de Información (OAIC) en www.oaic.gov.au.',
          ],
        },
        {
          title: 'Contacto del Oficial de Privacidad',
          paragraphs: [
            'Oficial de Privacidad — Domio.world',
            'Correo: privacy@domio.world',
            'Sitio web: https://domio.world',
          ],
        },
      ],
    },
    CO: {
      sections: [
        {
          title: 'Aviso de Privacidad — Domio.world',
          paragraphs: [
            'En cumplimiento de la Ley 1581 de 2012 y el Decreto 1377 de 2013, Domio.world informa a los titulares de datos personales sobre el tratamiento de su información.',
          ],
        },
        {
          title: '1. Responsable del tratamiento',
          paragraphs: [
            'Responsable: Domio.world. Contacto del Oficial de Protección de Datos / privacidad: privacy@domio.world. Sitio web: https://domio.world.',
          ],
        },
        {
          title: '2. Datos personales que recopilamos',
          paragraphs: [
            'Datos de identificación y contacto (nombre, correo electrónico, teléfono, rol); credenciales de cuenta; información de propiedades, arrendamientos, mantenimiento y finanzas; documentos de identidad y registros financieros que usted cargue; datos de uso y registros técnicos; y preferencias de comunicación.',
          ],
        },
        {
          title: '3. Finalidades del tratamiento',
          paragraphs: [
            'Prestación del servicio de gestión inmobiliaria; creación y administración de cuentas; procesamiento de documentos y funciones de inteligencia artificial autorizadas; notificaciones operativas y de seguridad; cumplimiento de obligaciones legales; y, con autorización expresa, envío de comunicaciones comerciales.',
          ],
        },
        {
          title: '4. Derechos del titular',
          paragraphs: [
            'Usted puede conocer, actualizar, rectificar y suprimir sus datos; revocar la autorización y/o solicitar la supresión cuando no exista deber legal o contractual de conservarlos; y presentar quejas ante la Superintendencia de Industria y Comercio (SIC).',
          ],
        },
        {
          title: '5. Transferencia y transmisión',
          paragraphs: [
            'Podemos transmitir datos a proveedores de hosting, correo, analítica y procesamiento de documentos ubicados en Colombia o en el exterior, bajo contratos que exigen niveles adecuados de protección. La transferencia internacional se realizará conforme a la normativa aplicable.',
          ],
        },
        {
          title: '6. Procedimiento para consultas y reclamos',
          paragraphs: [
            'Para ejercer sus derechos o presentar consultas y reclamos, escriba a privacy@domio.world indicando su nombre, identificación y solicitud. Responderemos en los plazos legales. Si no está conforme, puede acudir a la SIC: www.sic.gov.co.',
          ],
        },
      ],
    },
    ES: {
      sections: [
        {
          title: 'Información sobre Protección de Datos — Domio.world',
          paragraphs: [
            'De conformidad con el Reglamento (UE) 2016/679 (RGPD) y la Ley Orgánica 3/2018 de Protección de Datos Personales y garantía de los derechos digitales (LOPDGDD), le informamos del tratamiento de sus datos personales.',
          ],
        },
        {
          title: '1. Responsable del tratamiento',
          paragraphs: [
            'Responsable: Domio.world. Contacto: privacy@domio.world. Delegado de Protección de Datos (si aplica): privacy@domio.world.',
          ],
        },
        {
          title: '2. Datos que tratamos',
          paragraphs: [
            'Datos identificativos y de contacto; credenciales de acceso; datos relativos a inmuebles, arrendamientos y finanzas; documentos de identidad y datos financieros para verificación; datos de uso; y, en su caso, datos para comunicaciones comerciales con su consentimiento.',
          ],
        },
        {
          title: '3. Finalidades y base jurídica',
          paragraphs: [
            'Ejecución del contrato de servicio (art. 6.1.b RGPD); cumplimiento de obligaciones legales (art. 6.1.c); interés legítimo en seguridad y mejora del servicio (art. 6.1.f); consentimiento para datos sensibles, marketing y tratamientos opcionales (art. 6.1.a y art. 9.2.a cuando proceda).',
          ],
        },
        {
          title: '4. Destinatarios y encargados',
          paragraphs: [
            'Podemos comunicar datos a proveedores de infraestructura, correo electrónico, analítica y procesamiento documental/IA que actúan como encargados del tratamiento, con contrato conforme al art. 28 RGPD, así como a autoridades competentes cuando la ley lo exija.',
          ],
        },
        {
          title: '5. Transferencias internacionales',
          paragraphs: [
            'Si los datos se transfieren fuera del Espacio Económico Europeo, adoptaremos garantías adecuadas (cláusulas contractuales tipo, decisiones de adecuación u otras medidas previstas en el RGPD).',
          ],
        },
        {
          title: '6. Plazos de conservación',
          paragraphs: [
            'Conservaremos los datos mientras mantenga su cuenta y durante los plazos necesarios para obligaciones legales, reclamaciones y auditoría. Los datos de marketing se conservarán hasta que retire su consentimiento.',
          ],
        },
        {
          title: '7. Derechos y reclamaciones',
          paragraphs: [
            'Puede ejercer los derechos de acceso, rectificación, supresión, limitación, oposición y portabilidad, y retirar el consentimiento en cualquier momento, escribiendo a privacy@domio.world. Tiene derecho a reclamar ante la Agencia Española de Protección de Datos (www.aepd.es).',
          ],
        },
      ],
    },
  },
};
